/* eslint-disable @typescript-eslint/no-explicit-any */
import { MOCK_SESSION_ID } from '../constants/CommonConstants';
import { getSubDirectoryLocale } from '../lib/helper';
import { OFFERS_APP_DOMAIN, OFFERS_HUB_PATH, SUCCESS } from './apiConstants';

declare global {
  // eslint-disable-next-line no-var
  var loggerInstance: CallableFunction;
}

export const fetchMBEData = async (context: any, locale: string): Promise<any> => {
  const { req, res } = context;
  const { log } = global.loggerInstance('MBEService');
  let response = {};
  const requestHeader = {
    resolvedUrl: context.resolvedUrl,
    hostname: req?.headers['x-forwarded-host'],
    url: req?.url,
    referer: req?.headers?.referer ?? '',
    xHost: req?.headers['x-host'],
    requestId: req.headers['x-request-id'] ?? `${Date.now()}`,
    sessionToken: req?.cookies?.sessionID ?? MOCK_SESSION_ID,
  };

  const config: any = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Request-Id': requestHeader.requestId,
      'Accept-Language': locale ?? 'en-US',
      sessionToken: req?.cookies?.sessionID ?? '',
      'X-Host': requestHeader?.xHost,
    },
    body: JSON.stringify({
      sessionToken: requestHeader?.sessionToken ?? '',
    }),
  };

  const hostname = `${requestHeader.hostname}${requestHeader.url}`;
  const modifiedUrl = requestHeader?.resolvedUrl?.split('/') ?? '';
  const pageURI = modifiedUrl?.pop();
  const subDomain = getSubDirectoryLocale(locale);
  log.debug('[MBEService] pageURI & subDomain', pageURI, subDomain);
  log.debug('[MBEService] hostname', hostname);

  //http://phoenix.mi-offers-app-offersdev1.dev.cld.marriott.com/offers/details/last-minute-hotel-deals?offerid=OFF-041173
  const mbeAppDomain = OFFERS_APP_DOMAIN.replace('/offers/details/', '');
  const uri = `${mbeAppDomain}/offers/special-offers/details/${pageURI}`;
  log.debug('[MBEService] request config data', JSON.stringify(config), uri);

  try {
    await fetch(uri, config)
      .then(res => res.json())
      .then(data => {
        log.debug(`MBE Service API response: ${JSON.stringify(data)}`);
        const responseCode = data?.responseStatus?.code ?? '';
        const responeMessage = data?.responseStatus?.message ?? '';
        log.debug('MBE response code and response message', `${responseCode} ${responeMessage}`);
        if (responseCode === '200' && responeMessage === SUCCESS) {
          response = data ?? {};
        } else {
          res.writeHead(307, { Location: `${subDomain}${OFFERS_HUB_PATH}` });
          res.end();
        }
      });
  } catch (error) {
    log.debug('MBE Service Error Data Message', error);
  }
  return { response };
};
